import { Roles } from "@/models/user/roles";
import { PartialNetSuiteCustomer, PriceLevel } from "@/models/netsuite/netsuite";
import { SSOImpersonation } from "@/services/auth_service";
import { GlobalContext, GlobalMutations } from "./types";

export const addLoading = (context: GlobalContext, value: boolean) => {
  context.commit(GlobalMutations.SetLoading, value);
};

export const addLoggedIn = (context: GlobalContext, value: boolean) => {
  context.commit(GlobalMutations.SetLoggedIn, value);
};

export const addRole = (context: GlobalContext, value: Roles | null) => {
  context.commit(GlobalMutations.SetRole, value);
};

export const addMobile = (context: GlobalContext, value: boolean) => {
  context.commit(GlobalMutations.SetMobile, value);
};

export const addTablet = (context: GlobalContext, value: boolean) => {
  context.commit(GlobalMutations.SetTablet, value);
};

export const addMultiplier = (
  context: GlobalContext,
  value: PriceLevel | null
) => {
  context.commit(GlobalMutations.SetMultiplier, value ?? null);
};

export const addPriceLevels = (context: GlobalContext, value: PriceLevel[]) => {
  context.commit(GlobalMutations.SetPriceLevels, value);
};

export const addCustomers = (context: GlobalContext, value: PartialNetSuiteCustomer[]) => {
  context.commit(GlobalMutations.SetCustomers, value);
};

export const addAuthToken = (context: GlobalContext, value: string | null) => {
  context.commit(GlobalMutations.SetAuthToken, value);
};

export const addImpersonation = (context: GlobalContext, value: SSOImpersonation | null) => {
  context.commit(GlobalMutations.SetImpersonation, value);
};
